(function ($) {

    'use strict';

    var idleTimeMilli = 0,
        idleIntervalMilli = 60000,
        idleTimer,
        $dialog,
        getParams = function(url) {
            var parser = document.createElement('a'),
                parms = [];
            parser.href = url;
            var kvps = parser.search.substring(1).split('&');
            for (var i = 0; i < kvps.length; i = i + 1) {
                var parts = kvps[i].split('=');
                parms[parts[0]] = decodeURIComponent(parts[1]);
            }
            return parms;
        },
        resetIdleTime = function () {
            idleTimeMilli = 0;
        },
        getAuthExp = function () {
            if (!evExpCookieName || !document.cookie) {
                return;
            }

            var keyValueParts = document.cookie.split(';');

            for (var i = 0; i < keyValueParts.length; i++) {
                var parts = keyValueParts[i].trim().split('='),
                    parsed;
                if (parts[0] === evExpCookieName) {
                    return JSON.parse(decodeURIComponent(parts[1]), function (key, value) {
                        return (key === 'expires') ? new Date(value) : value;
                    });
                }
            }

            return;
        },
        refreshAuth = function () {
            var params;
            return $.get('/hapi/v1/users/current')
                .done(function() {
                    if ($('body').hasClass('ev-modal-open')) {
                        $dialog.modal('hide');
                    }
                })
                .fail(function (xhr) {
                    if (xhr.status === 401) {
                        params = getParams(window.location.href);
                        if (params.rl_type) {
                            window.location.href = '/hapi/lti/adv/resource/expired';
                        } else {
                            window.location.reload();
                        }
                    } else {
                        alert('An unexpected error occurred while refreshing your session!');
                    }
                });
        },
        handleExpiration = function () {
            var authExp = getAuthExp(),
                warningThresholdMilli,
                warningTime;

            if (!authExp || !authExp.expires) {
                console.log('ev-auth-exp: Expiration cookie not found');
                refreshAuth()
                .done(function () {
                    setTimeout(handleExpiration, idleIntervalMilli);
                })
                .fail(function () {
                    clearInterval(idleTimer);
                });
                return;
            }

            console.log('ev-auth-exp: Authentication expires: ' + authExp.expires);

            warningThresholdMilli = authExp.timespan / 4;
            warningTime = new Date(authExp.expires.getTime() - warningThresholdMilli);
            // If we're within 1/4 of the time to expiration
            if (warningTime < Date.now()) {
                // If user has been active within threshold...automatically refresh...
                if (idleTimeMilli < warningThresholdMilli) {
                    console.log('ev-auth-exp: Recent activity detected...automatically refreshing authentication');
                    refreshAuth()
                    .done(function () {
                        setTimeout(handleExpiration, idleIntervalMilli);
                    })
                    .fail(function () {
                        clearInterval(idleTimer);
                    });
                }
                // ...otherwise notify user
                else {
                    if (!$('body').hasClass('ev-modal-open')) {
                        $dialog.modal('show');
                    }
                    setTimeout(handleExpiration, idleIntervalMilli);
                }
            } else {
                console.log('ev-auth-exp: Seconds until threshold reached: ' + Math.floor((warningTime.getTime() - Date.now()) / 1000));
                setTimeout(handleExpiration, idleIntervalMilli);
            }
        };

    $(document).ready(function() {
        // If we load the page and we have no expiration cookie, than auth must not be mandatory (or expiration handled) so bail
        if (!getAuthExp()) {
            console.log('ev-auth-exp: No expiration cookie available on DOM ready');
            return;
        }

        try {
            // Bail if we're in a frame on a page which is already handling expiration
            if (window.self !== window.top &&
                window.parent &&
                $('#confirmAuthRefresh', window.parent.document).length) {
                console.log('ev-auth-exp: Parent is handling expiration');
                return;
            }
        } catch(err) {
            // Do nothing
        }

        idleTimer = setInterval(function () {
            console.log('ev-auth-exp: Idle time (secs): ' + idleTimeMilli / 1000);
            idleTimeMilli = idleTimeMilli + idleIntervalMilli;
        }, idleIntervalMilli);

        $dialog = $('#confirmAuthRefresh');
        // We've broken modal plugin initialization w/ our custom prefixing so I'm working around that here
        $dialog.data({
            'backdrop': 'static',
            'keyboard': false,
            'show': false
        });
        $dialog.modal();
        $dialog.on('shown.bs.modal', function () {
            $('.ev-btn.ev-btn-default', $dialog).focus();
        });
        $dialog.data('bs.ev-modal', $dialog.data('bs.modal'));
        $('.ev-closeModal', $dialog).on('click keypress', function (e) {
            if (e.keyCode !== undefined && e.keyCode !== 13) {
                return;
            }
            clearTimeout(handleExpiration);
            refreshAuth()
            .done(function () {
                setTimeout(handleExpiration, idleIntervalMilli);
            })
            .fail(function () {
                clearInterval(idleTimer);
            });
        });

        window.onload = resetIdleTime;
        window.onmousemove = resetIdleTime;
        window.onmousedown = resetIdleTime;
        window.ontouchstart = resetIdleTime;
        window.onclick = resetIdleTime;
        window.onkeydown = resetIdleTime;   
        window.addEventListener('scroll', resetIdleTime, true); //     

        handleExpiration();
    });

}(jQuery));
